const defaultContext = Object.freeze({
  environment: "development",
  loggingEnabled: false,
  baseUrl: "",
  initialized: false
});
let DashboardQueryContext = defaultContext;
const initDashboardQueryContext = (options) => {
  if (DashboardQueryContext.initialized) {
    throw new Error(
      "DashboardQueryContext has already been initialized. It cannot be initialized twice."
    );
  }
  DashboardQueryContext = Object.freeze({
    ...defaultContext,
    ...options,
    initialized: true
  });
  return DashboardQueryContext;
};
const setDashboardQueryContext = (config) => {
  DashboardQueryContext = Object.freeze({
    ...DashboardQueryContext,
    ...config
  });
};
const resetDashboardQueryContextForTesting = () => {
  DashboardQueryContext = defaultContext;
};
export {
  DashboardQueryContext,
  initDashboardQueryContext,
  resetDashboardQueryContextForTesting,
  setDashboardQueryContext
};
//# sourceMappingURL=context.js.map
